import Search from "./Search";

export default {
    searchById: Search.byId
}
